import { render, staticRenderFns } from "./tableComissionTenants.vue?vue&type=template&id=dd0e2434&scoped=true&"
import script from "./tableComissionTenants.vue?vue&type=script&lang=js&"
export * from "./tableComissionTenants.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=dd0e2434&scoped=true&lang=css&"
import style1 from "./tableComissionTenants.vue?vue&type=style&index=1&id=dd0e2434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0e2434",
  null
  
)

export default component.exports